module.exports = __webpack_public_path__ + "media/personas/bg-getting-more-specific-3ad24438.jpg";